import roles from '@/api/roles'

export default {
    namespaced: true,
    state: {
        items: []
    },
    getters: {},
    actions: {
        fetchAll ({ commit }) {
            return new Promise((resolve, reject) => {
                roles.index().then(response => {
                    commit('setItems', response.data)
                    resolve(response.data)
                }).catch(error => reject(error));
            })
        }
    },
    mutations: {
        setItems (state, items) {
            state.items = items
        }
    }
}